import React from "react";
import Validationtest from "../../CoberturaFTTH/validationtest";
// import Valoint from "../../CoberturaFTTH/valoint delete";
// import Valout from "../../CoberturaFTTH/valout";
import Dashboard from "../../Dasboard/Dashboard";

export const CreateSol = (props) => {
  return (
    <>
      <Dashboard
        MInicio={""}
        Msolicitudes={""}
        Mservicios={""}
        Mcompra={"active"}
        Mcunyompra={""}
        Mempaquetar={""}
        Mcpotenciales={""}
        Madminportal={""}
        Mcampaña={""}
        Mtv={""}
      >
      <section style={{ margin: 1, padding: "1rem" }}>
      <Validationtest ruta={props.ruta} step={props.step} steps={props.steps} classBack={"prin"} classDiv={"con"}/>
        {/* <Valout
          ruta={"/Cotizadorsol "}
          step={1}
          steps={props.steps}
          classBack={""}
          classDiv={""}
        /> */}
      </section>
      </Dashboard>
    </>
  );
};


// ## Summary
// The `CreateSol` function is a React component that renders a dashboard and a `Validationtest` component. It is used to create a page for purchasing a service.

// ## Example Usage
// ```javascript
// <CreateSol ruta={"/Cotizadorsol "} step={1} steps={props.steps} />
// ```

// ## Code Analysis
// ### Inputs
// - `props`: An object containing the properties passed to the `CreateSol` component.
// ___
// ### Flow
// 1. The `CreateSol` component renders a `Dashboard` component with specific menu items highlighted.
// 2. It also renders a `Validationtest` component, passing the `ruta`, `step`, and `steps` properties as props.
// 3. The `Validationtest` component is responsible for validating the availability of a service and displaying the necessary form inputs.
// 4. The user can input their address and other details to check if the service is available.
// 5. The user can submit the form to proceed with the service purchase.
// ___
// ### Outputs
// - The rendered page with the dashboard and the `Validationtest` component.
// ___
